/*
  File: assets/ozplug-footer.js
  Purpose: Dawn-safe OZPLUG custom footer interactions
*/

(function () {
  'use strict';

  if (window.OZPlugFooterReady) return;
  window.OZPlugFooterReady = true;

  const ROOT_SELECTOR = "[data-oz-footer]";
  const INITIALIZED_ATTRIBUTE = "data-oz-footer-initialized";
  const MOBILE_QUERY = window.matchMedia("(max-width: 749px)");

  function initFooter(root) {
    if (!root || root.hasAttribute(INITIALIZED_ATTRIBUTE)) return;

    root.setAttribute(INITIALIZED_ATTRIBUTE, "true");

    const toggles = Array.from(
      root.querySelectorAll("[data-oz-footer-menu-toggle]")
    );

    function closeAll(exceptButton) {
      toggles.forEach(function (button) {
        if (button === exceptButton) return;

        const content = getControlledContent(root, button);

        button.setAttribute("aria-expanded", "false");
        content?.classList.remove("is-open");
      });
    }

    toggles.forEach(function (button) {
      button.addEventListener("click", function () {
        if (!MOBILE_QUERY.matches) return;

        const content = getControlledContent(root, button);
        const willOpen = button.getAttribute("aria-expanded") !== "true";

        closeAll(button);

        button.setAttribute("aria-expanded", String(willOpen));
        content?.classList.toggle("is-open", willOpen);
      });
    });

    const complianceItems = Array.from(
      root.querySelectorAll(".oz-footer__legal-accordion details")
    );

    complianceItems.forEach(function (item) {
      item.addEventListener("toggle", function () {
        if (!item.open) return;

        complianceItems.forEach(function (otherItem) {
          if (otherItem !== item) {
            otherItem.removeAttribute("open");
          }
        });
      });
    });

    function syncForViewport() {
      if (!MOBILE_QUERY.matches) {
        toggles.forEach(function (button) {
          const content = getControlledContent(root, button);

          button.setAttribute("aria-expanded", "false");
          content?.classList.remove("is-open");
        });
      }
    }

    if (typeof MOBILE_QUERY.addEventListener === "function") {
      MOBILE_QUERY.addEventListener("change", syncForViewport);
    } else if (typeof MOBILE_QUERY.addListener === "function") {
      MOBILE_QUERY.addListener(syncForViewport);
    }

    root.ozFooterCleanup = function () {
      if (typeof MOBILE_QUERY.removeEventListener === "function") {
        MOBILE_QUERY.removeEventListener("change", syncForViewport);
      } else if (typeof MOBILE_QUERY.removeListener === "function") {
        MOBILE_QUERY.removeListener(syncForViewport);
      }
    };
  }

  function getControlledContent(root, button) {
    const contentId = button.getAttribute("aria-controls");

    if (!contentId) return null;

    return root.querySelector(`#${escapeSelector(contentId)}`);
  }

  function escapeSelector(value) {
    if (window.CSS && typeof window.CSS.escape === "function") {
      return window.CSS.escape(value);
    }

    return value.replace(/([^\w-])/g, "\\$1");
  }

  function initAll(context) {
    (context || document)
      .querySelectorAll(ROOT_SELECTOR)
      .forEach(initFooter);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    const root = event.target.querySelector(ROOT_SELECTOR);

    if (root && typeof root.ozFooterCleanup === "function") {
      root.ozFooterCleanup();
    }
  });
})();
